import { useState, useEffect } from 'react';
import { ReactComponent as Uploader } from '../assets/uploader.svg';

export default function FileUploader({
  onFileUpload,
}: {
  onFileUpload: (files: FileList | null) => void;
}) {
  const [dragging, setDragging] = useState(false);
  const onFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    onFileUpload(event.dataTransfer.files);
  };
  const onDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragging(false);
  };
  const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragging(true);
  };
  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    onFileUpload(event.currentTarget.files);
  };
  return (
    <div
      className='tw-flex tw-items-center tw-justify-center tw-w-full'
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={(event) => onFileDrop(event)}
    >
      <label
        htmlFor='dropzone-file'
        className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-34 tw-border-2 tw-border-gray-300 tw-border-dashed tw-rounded-lg tw-cursor-pointer tw-bg-gray-50 tw-dark:hover:bg-bray-800 tw-dark:bg-gray-700 hover:bg-gray-100'
      >
        <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-5 tw-pb-6'>
          <Uploader />
          <p className='tw-mb-2 tw-text-sm tw-text-gray-500'>
            <span className='font-semibold'>Click to upload</span> or drag and
            drop
          </p>
          <p className='tw-text-xs tw-text-gray-500'>Text file</p>
        </div>
        <input
          id='dropzone-file'
          type='file'
          className='tw-hidden'
          onChange={handleUpload}
        />
      </label>
    </div>
  );
}
